// extracted by mini-css-extract-plugin
export default {"container":"Products_container__c16b3","products":"Products_products__7cxzA","menu":"Products_menu__AEWxR","list":"Products_list__+FeZF","product":"Products_product__GuayB"};